import { Flex,Table } from 'antd'
import React, { useEffect, useState } from 'react'
import classes from './invoice.module.css' 
import ReportStateTag from '../../cpn/StateTag';
import InvoiceAddReportEdit from './InvoiceAddReportEdit';    
import InvoiceEditReportEdit from './InvoiceEditReportEdit';
import Copy from '../../cpn/Copy';
import InvoiceCheck from './InvoiceCheck';
function InvoiceListReport(props) {

     // 格式化金额显示
     const formatCurrency = (text) => (
         <span style={{color:'#FF6600'}}>
             ￥{Number(text).toLocaleString('zh-CN', {
                 minimumFractionDigits: 2,
                 maximumFractionDigits: 2
             })}
         </span>
     );
     const [list, setList] = useState([])
    useEffect(() => {
        if(props.kpsq_data){
            setList([...props.kpsq_data].sort((a, b) => a.kpsq_id - b.kpsq_id))
        }
    }, [props.kpsq_data])
     // 基础列定义
     const columns = [
        {  
            dataIndex: 'index', 
            width: 42, 
            key: 'index' ,
            render: (text, record, index) => index + 1,
            title: '序号',
        },
        { 
            title: '开票客户', 
            dataIndex: 'kpsq_kh_name', 
            width: 200, 
            key: 'kpsq_kh_name',
            render: (text, record) => {
                if(record.kpsq_state === '1'){
                    return <InvoiceEditReportEdit
                                kpsq_id={record.kpsq_id}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                kpsq_bzd_id={record.kpsq_bzd_id}
                                kpsq_price={record.kpsq_price}
                                kpsq_content={record.kpsq_content}
                                kpsq_date={record.kpsq_date}
                                kpsq_bzd_date={props.dsbzd_date}
                                kpsq_bzd_date_end={props.dsbzd_date_end}
                                kpsq_bzd_name={props.dsbzd_name}
                                kpsq_type_id={record.kpsq_type_id}
                                kpsq_type_name={record.kpsq_type_name}
                                kpsq_kh_id={record.kpsq_kh_id}
                                kpsq_kh_name={record.kpsq_kh_name}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                kpsq_num={record.kpsq_num}
                                kpsq_amount={record.kpsq_amount}
                                kpsq_uid={record.kpsq_uid}
                                kpsq_state={record.kpsq_state}
                                kpsq_state_time={record.kpsq_state_time}
                                kpsq_uname={record.kpsq_uname}
                                kpsq_image_name={record.kpsq_image_name}
                                kpsq_image_file={record.kpsq_image_file}
                                kpsq_name={record.kpsq_name}
                                kpsq_bm_id={record.kpsq_bm_id}
                                kpsq_bm_name={record.kpsq_bm_name}
                                kpsq_khyhzh_id={record.kpsq_khyhzh_id}
                                kpsq_khyhzh_name={record.kpsq_khyhzh_name}
                                kpsq_ctime={record.kpsq_ctime}
                            />
                }else{
                    return <InvoiceCheck
                                type='button'
                                kpsq_id={record.kpsq_id}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                kpsq_bzd_id={record.kpsq_bzd_id}
                                kpsq_price={record.kpsq_price}
                                kpsq_content={record.kpsq_content}
                                kpsq_date={record.kpsq_date}
                                dsbzd_date={props.dsbzd_date}
                                dsbzd_date_end={props.dsbzd_date_end}
                                dsbzd_name={props.dsbzd_name}
                                kpsq_type_id={record.kpsq_type_id}
                                kpsq_type_name={record.kpsq_type_name}
                                kpsq_kh_id={record.kpsq_kh_id}
                                kpsq_kh_name={record.kpsq_kh_name}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                kpsq_num={record.kpsq_num}
                                kpsq_amount={record.kpsq_amount}
                                kpsq_uid={record.kpsq_uid}
                                kpsq_state={record.kpsq_state}
                                kpsq_image_name={record.kpsq_image_name}
                                kpsq_image_file={record.kpsq_image_file}
                                dsbzd_id={props.dsbzd_id}
                                kpsq_name={record.kpsq_name}
                                kpsq_bm_id={record.kpsq_bm_id}
                                kpsq_bm_name={record.kpsq_bm_name}
                                kpsq_khyhzh_id={record.kpsq_khyhzh_id}
                                kpsq_khyhzh_name={record.kpsq_khyhzh_name}
                                kpsq_ctime={record.kpsq_ctime}
                            />
                }
            }
        },
        { 
             title: '开票金额', 
             dataIndex: 'kpsq_amount',    
             width: 200, 
             key: 'kpsq_amount', 
             render: formatCurrency 
         },
        { 
            title: '开票项目', 
            dataIndex: 'kpsq_name', 
            key: 'kpsq_name',
            render: (text, record) => <Copy title={record.kpsq_content}/>
        },    
        {
            title: '状态',
            dataIndex: 'kpsq_state',
            key: 'kpsq_state',
            render: (text) => <ReportStateTag state={text} />,
            width: 80,
        },
        {
            title: '编号',
            width: 60, 
            key:'kpsq_id',
            dataIndex:'kpsq_id',            
        },
       
     ];

    return (
        <div>
            <Flex align='center' justify='space-between' style={{marginTop:'10px'}}>
                <div style={{fontSize:'16px',fontWeight:'bold',color:'#FF6600'}}>开票申请</div>                
                <InvoiceAddReportEdit  
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                    dsbzd_id={props.dsbzd_id}                                                                           
                    dsbzd_date={props.dsbzd_date}
                    dsbzd_date_end={props.dsbzd_date_end}
                    dsbzd_name={props.dsbzd_name}
                    qy_id={props.qy_id}
                    qy_name={props.qy_name}
                    dsbzd_uid={props.dsbzd_uid}
                    dsbzd_state={props.dsbzd_state}
                    dsbzd_bm_id={props.dsbzd_bm_id}
                    dsbzd_bm_name={props.dsbzd_bm_name}
                    dsbzd_dscp_id={props.dsbzd_dscp_id}
                    dsbzd_dscp_name={props.dsbzd_dscp_name}
                    dsbzd_kh_id={props.dsbzd_kh_id}
                    dsbzd_kh_name={props.dsbzd_kh_name}
                />
            </Flex>
            <Table 
                className={classes.orangeHeader}
                dataSource={list}
                columns={columns}
                pagination={false}
                style={{marginTop:'10px'}}
                size='small'
                rowKey="kpsq_id"                    
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.kpsq_amount || 0), 0);    
                    if(total>0){
                        return (
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={0} key="summary-0" colSpan={1}></Table.Summary.Cell>
                                <Table.Summary.Cell index={1} key="summary-1" colSpan={1}></Table.Summary.Cell> 
                                <Table.Summary.Cell index={2} key="summary-2" colSpan={1}>
                                    <span style={{color:'#FF6600'}}>合计￥{Number(total).toLocaleString('zh-CN', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })}</span>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={3} key="summary-3" colSpan={columns.length - 2} ></Table.Summary.Cell>
                            </Table.Summary.Row>
                        );
                    }
                    return null;
                }}
                locale={{
                    emptyText: '暂无开票申请' // This will display text when the table is empty
                }}
            />
        </div>
    )
}

export default InvoiceListReport